module.exports = __webpack_public_path__ + "img/28@3x.1d6d3eb0.png";